import { useAppDisplayModeContext } from '@archipro-design/aria';
import type { FilterStates } from '~/modules/search/type/filter-state';
import { SearchFilterDesktop } from './SearchFilter.desktop';
import { SearchFilterMobile } from './SearchFilter.mobile';
import type { useSearchFilters } from '@modules/search/hook/use-search-filters';

export interface SearchFilterProp {
    initialStates?: FilterStates | null;
    filterDrawerOpen: boolean;
    toggleFilterDrawer: () => void;
    searchFilters: ReturnType<typeof useSearchFilters>;
    disableSort?: boolean;
    disableToggleFilter?: boolean;
}

export const SearchFilter: React.FC<SearchFilterProp> = (props) => {
    const { desktop } = useAppDisplayModeContext();

    return !desktop ? (
        <SearchFilterMobile {...props} />
    ) : (
        <SearchFilterDesktop {...props} />
    );
};
